/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from "constants/Colors";

export const EnquiryCardContainer = styled.div`
    display: flex;
    flex-flow: wrap;
`

export const Content = styled.div`
    // width: 33%;
    margin-bottom: 10px;
`

export const Title = styled.h3`
    color: ${Colors.PRIMARY1}
    font-size: 14px;
    text-transform: uppercase;
    line-height: 1.5;
    margin: 0;
`

export const Text = styled.span`
    color: ${Colors.GRAY[7]}
    font-size: 18px;
    font-weight: 600;
    word-break: break-word;
`

